
import React from "react";
import "./css/HiringBanner.css";

const HiringBanner = ({ onNavigate, navHidden }) => {
  return (
    <section className={`hiring-banner ${navHidden ? 'nav-hidden' : ''}`}>
      <div className="scrolling-text">
        We are Hiring, Developers, Graphic Artists, Social Media Ad Management and Sales. Please apply{" "}
        <span 
          className="hiring-link" 
          onClick={() => onNavigate("employment")}
        >
          here
        </span>
        .
      </div>
    </section>
  );
};

export default HiringBanner;
